// Before we have proper i18n framework, here controls copy across angular / emails etc
const personalizations = require('./config/personalizations.json');

module.exports = {
  getPersonalizationlabel: function(key, value) {
    const preference = _.find(personalizations, {label: key});
    return _.get(_.find(_.get(preference, 'values'), {value: value}), 'label');
  },
};
